import { Case, Patient } from '@/models';
import { ImageService } from '@/services';
import { Component, inject, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-case-item',
    templateUrl: './case-item.component.html',
    styleUrls: ['./case-item.component.scss'],
    standalone: false
})
export class CaseItemComponent implements OnInit {
  @Input() case: Case;

  url: string;

  ngOnInit(): void {
    if (!this.case || !this.case.patient) {
      this.url = 'icon';
      return;
    }
    this.url = this.getImageUrl(this.case.patient);
  }

  private imageService = inject(ImageService);

  getImageUrl(patient: Patient): string {
    if (!patient.properties) return '';
    var imgId = patient.properties.find(x => x.property.name == 'foto')?.value;
    if (imgId) {
      return this.imageService.buildImageUrl(imgId);
    }
    return '';
  }

  getPatientProperty(property: string, patient: Patient) {
    if (!patient.properties) return;
    return patient.properties.find(x => x.property.name == property)?.value;
  }
}